<template>
    <div v-wechat-title="title" class="padding10">
        <h1>{{ today }}</h1>
        <el-row v-if="monitors && monitors.length > 0">
            <el-col :xl="defaultOperatingRoomCount" :md="defaultOperatingRoomCount" v-for="(p, index) in monitors" :key="index + '_' + ((p.surgery_info && p.surgery_info.id) || '')" class="padding5">
                <el-card :body-style="{ padding: '5px' }">
                    <div class="card-header">
                        <el-row class="height40 padding10 padding-none-v" type="flex" align="middle">
                            <el-col :span="22" style="line-height: 40px">
                                <b>{{ p.location }}</b>
                                <span v-if="IsRescue(p)" style="background-color: red; font-size: smaller; color: white">抢救中</span>
                                &nbsp;&nbsp;
                                <span class="iconfont icon-tishi" title="当前手术间未具备手术资格" v-if="p.check_result == '不合格'"></span>
                                <span v-if="p.surgery_info" style="float: right">
                                    <b class="fg-primary">{{ p.surgery_info.patient_name }}</b>
                                    {{ p.surgery_info && `${p.surgery_info.sex || '--'}/${p.surgery_info.age || '--岁'}` }}
                                </span>
                                <template v-else>(空)</template>
                            </el-col>
                            <el-col :span="2" class="align-right" title="查看麻醉单">
                                <span v-if="p.surgery_info" class="cus-button is-circle el-icon-document" style="background: whitesmoke" @click="loadDocument(p)"></span>
                            </el-col>
                            <el-col :span="2" class="align-right" title="查看术中监控">
                                <font-awesome-icon v-if="p.surgery_info" class="screenfull-svg" icon="expand-alt" @click="loadView(p)" />
                            </el-col>
                        </el-row>
                    </div>
                    <div class="card-content">
                        <div :style="{ height: `${rowTototalHeight}px` }" wrap-class="scrollbar-wrapper-y" v-if="p.surgery_info && p.surgery_info.patient_name">
                            <el-row>
                                <el-col :span="24" class="padding10">
                                    <el-row style="max-height: 50px" :title="(p.surgery_info && p.surgery_info.diseases) || '--'">
                                        <el-col :span="24" style="font-size: 16px" class="ellipsis padding-none-h"
                                            ><span class="fg-info textoverflow">手术诊断：</span>{{ (p.surgery_info && p.surgery_info.diseases) || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row style="max-height: 50px" :title="(p.surgery_info && p.surgery_info.surgeries) || '--'">
                                        <el-col :span="24" style="font-size: 16px" class="ellipsis padding-none-h"
                                            ><span class="fg-info textoverflow">手术名称：</span>{{ (p.surgery_info && p.surgery_info.surgeries) || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row style="max-height: 50px" :title="(p.surgery_info && p.surgery_info.anaes_methods) || '--'">
                                        <el-col :span="24" style="font-size: 16px" class="ellipsis padding-none-h"
                                            ><span class="fg-info textoverflow">麻醉方式：</span>{{ (p.surgery_info && p.surgery_info.anaes_methods) || '--' }}</el-col
                                        >
                                    </el-row>
                                    <div style="height: 80px; border-bottom: dashed 0.5px lightgrey" v-if="isShowOperatingDefaultField == `1`">
                                        <el-row
                                            ><el-col :span="12">手术医师：{{ (p.surgery_info && p.surgery_info.surgeon) || '--' }}</el-col
                                            ><el-col :span="12"
                                                >手术助手：{{ (p.surgery_info && p.surgery_info.surgeon_assistants) || joinWorker(p.surgery_info.fact_anes_assistants) }}</el-col
                                            ></el-row
                                        >
                                        <el-row
                                            ><el-col :span="12">麻醉医师：{{ (p.surgery_info && p.surgery_info.anes_doctor) || '--' }}</el-col
                                            ><el-col :span="12">麻醉助手：{{ (p.surgery_info && p.surgery_info.anes_assistants) || '--' }}</el-col></el-row
                                        >
                                        <el-row
                                            ><el-col :span="12">巡回护士：{{ (p.surgery_info && p.surgery_info.circuit_nurse) || joinWorker(p.surgery_info.fact_equipment_nurse) }}</el-col>
                                            <el-col :span="12">器械护士：{{ (p.surgery_info && p.surgery_info.equipment_nurse) || joinWorker(p.surgery_info.fact_circuit_nurse) }}</el-col>
                                        </el-row>
                                    </div>
                                    <div style="height: 27px; border-bottom: dashed 0.5px lightgrey" v-else-if="isShowOperatingDefaultField == `2`">
                                        <el-row>
                                            <el-col :span="12">手术医师：{{ (p.surgery_info && p.surgery_info.surgeon) || '--' }}</el-col>
                                            <el-col :span="12">麻醉医师：{{ (p.surgery_info && p.surgery_info.anes_doctor) || '--' }}</el-col>
                                        </el-row>
                                    </div>
                                    <el-row class="dt"
                                        ><el-col :span="24">麻醉开始时间：<text-formatter type="datetime" v-model="p.surgery_info.anesthesia_begin" v-if="p.surgery_info"></text-formatter></el-col
                                    ></el-row>
                                    <el-row class="dt"
                                        ><el-col :span="24">手术开始时间：<text-formatter type="datetime" v-model="p.surgery_info.operation_begin" v-if="p.surgery_info"></text-formatter></el-col
                                    ></el-row>

                                    <!-- <el-row
                                        ><el-col :span="12" v-for="item in p.monitor_datas" :key="item.physio_param.id">
                                            <div class="tag-group">
                                                <div class="tag-border">
                                                    <span class="fg-info">{{ item.physio_param.alias || item.physio_param.name }}</span>
                                                    <b :class="{ 'fg-danger': item.is_warning }">{{ item.value }} {{ item.physio_param.unit }}</b>
                                                </div>
                                            </div>
                                        </el-col>
                                    </el-row> -->
                                    <template v-for="(item, itemindex) in p.monitor_datas">
                                        <el-row :key="item.physio_param.id" v-if="itemindex % 2 == 0" class="textoverflow"
                                            ><el-col :span="12">
                                                <b style="font-size: 16px">{{ item.physio_param.alias || item.physio_param.name }}</b>
                                                <b :class="{ 'fg-danger': item.is_warning }" style="font-size: 22px">{{ item.value }}</b>
                                                <b style="font-size: 16px">{{ item.physio_param.unit }}</b>
                                            </el-col>

                                            <el-col :span="12" v-if="itemindex + 1 < p.monitor_datas.length">
                                                <b style="font-size: 16px">{{ p.monitor_datas[itemindex + 1].physio_param.alias || p.monitor_datas[itemindex + 1].physio_param.name }}</b>
                                                <b :class="{ 'fg-danger': p.monitor_datas[itemindex + 1].is_warning }" style="font-size: 22px">{{ p.monitor_datas[itemindex + 1].value }} </b>
                                                <b style="font-size: 16px">{{ p.monitor_datas[itemindex + 1].physio_param.unit }}</b>
                                            </el-col>
                                        </el-row>
                                    </template>
                                    <div class="bottom" style="padding-top: 2px">
                                        <div>
                                            <span
                                                v-for="dv in p.surgery_info.use_devices"
                                                :key="dv.id"
                                                class="ellipsis padding5 font-size12"
                                                style="margin-right: 10px; background: #fff; height: 20px; line-height: 20px; display: inline-block; max-width: 100px"
                                                :title="dv.device.name"
                                                >{{ dv.device.name }}</span
                                            >
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="no-bed" v-else :style="{ height: `${autoheight()}px` }">
                            <font-awesome-icon :icon="['fas', 'bed']"></font-awesome-icon>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <p v-else class="no-surgery">暂无手术间</p>
        <pdf-frame :base64="base64" :visible.sync="pdfvisible" title="麻醉记录单"></pdf-frame>

        <!-- 弹窗 -->
        <el-dialog ref="tk" title="查看术中监控" :visible.sync="dialogVisible" width="95%" top="15vh">
            <div v-if="operationRoomMonitor" style="height: 100%">
                <div :body-style="{ padding: '5px', height: '100%' }">
                    <div class="card-header-dialog">
                        <el-row class="height40 padding10 padding-none-v" type="flex" align="middle">
                            <el-col :span="22" style="line-height: 40px">
                                <b>{{ operationRoomMonitor.location }}</b>
                                <span v-if="IsRescue(operationRoomMonitor)" style="background-color: red; font-size: smaller; color: white">抢救中</span>
                                &nbsp;&nbsp;
                                <span class="iconfont icon-tishi" title="当前手术间未具备手术资格" v-if="operationRoomMonitor.check_result == '不合格'"></span>
                                <span v-if="operationRoomMonitor.surgery_info" style="float: right">
                                    <b class="fg-primary">{{ operationRoomMonitor.surgery_info.patient_name }}</b>
                                    {{ operationRoomMonitor.surgery_info && `${operationRoomMonitor.surgery_info.sex || '--'}/${operationRoomMonitor.surgery_info.age || '--岁'}` }}
                                </span>
                                <template v-else>(空)</template>
                            </el-col>
                            <el-col :span="2" class="align-right" title="查看麻醉单">
                                <span
                                    v-if="operationRoomMonitor.surgery_info"
                                    class="cus-button is-circle el-icon-document"
                                    style="background: whitesmoke"
                                    @click="loadDocument(operationRoomMonitor)"
                                ></span>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="card-content-dialog fontClass">
                        <el-row>
                            <el-col :span="24" class="padding10">
                                <div class="fontClass">
                                    <el-row style="max-height: 50px">
                                        <el-col :span="24"
                                            ><span class="fg-info">手术诊断：</span>{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.diseases) || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row style="max-height: 50px">
                                        <el-col :span="24"
                                            ><span class="fg-info">手术名称：</span>{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.surgeries) || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row>
                                        <el-col :span="24" class="ellipsis padding5 padding-none-h"
                                            ><span class="fg-info">麻醉方式：</span>{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.anaes_methods) || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row v-if="isShowOperatingDefaultField == `2`"
                                        ><el-col :span="12">手术医师：{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.surgeon) || '--' }}</el-col
                                        ><el-col :span="12"
                                            >麻醉医师：{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.anes_doctor) || '--' }}</el-col
                                        ></el-row
                                    >
                                    <el-row v-if="isShowOperatingDefaultField == `1`"
                                        ><el-col :span="12">手术医师：{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.surgeon) || '--' }}</el-col
                                        ><el-col :span="12"
                                            >手术助手：{{
                                                (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.surgeon_assistants) ||
                                                joinWorker(operationRoomMonitor.surgery_info.fact_anes_assistants)
                                            }}</el-col
                                        ></el-row
                                    >
                                    <el-row v-if="isShowOperatingDefaultField == `1`"
                                        ><el-col :span="12">麻醉医师：{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.anes_doctor) || '--' }}</el-col
                                        ><el-col :span="12">麻醉助手：{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.anes_assistants) || '--' }}</el-col></el-row
                                    >
                                    <el-row v-if="isShowOperatingDefaultField == `1`"
                                        ><el-col :span="12"
                                            >巡回护士：{{
                                                (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.circuit_nurse) ||
                                                joinWorker(operationRoomMonitor.surgery_info.fact_equipment_nurse)
                                            }}</el-col
                                        >
                                        <el-col :span="12"
                                            >器械护士：{{
                                                (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.equipment_nurse) ||
                                                joinWorker(operationRoomMonitor.surgery_info.fact_circuit_nurse)
                                            }}</el-col
                                        >
                                    </el-row>

                                    <el-row class="dt"
                                        ><el-col :span="24"
                                            >麻醉开始时间：<text-formatter
                                                type="datetime"
                                                v-model="operationRoomMonitor.surgery_info.anesthesia_begin"
                                                v-if="operationRoomMonitor.surgery_info"
                                            ></text-formatter></el-col
                                    ></el-row>
                                    <!-- <el-row v-for="item in operationRoomMonitor.monitor_datas" :key="item.physio_param.id"
                                            ><el-col :span="12">
                                                <span class="fg-info">{{ item.physio_param.alias || item.physio_param.name }}</span>
                                                <b :class="{ 'fg-danger': item.is_warning }">{{ item.value }} {{ item.physio_param.unit }}</b>
                                            </el-col>
                                        </el-row> -->
                                    <template v-for="(item, itemindex) in operationRoomMonitor.monitor_datas">
                                        <el-row :key="item.physio_param.id" v-if="itemindex % 2 == 0"
                                            ><el-col :span="12">
                                                <b>
                                                    <span :style="{ 'font-size': nameFontSize }">{{ item.physio_param.alias || item.physio_param.name }}</span>
                                                    <span :class="{ 'fg-danger': item.is_warning }" :style="{ 'font-size': dataFontSize }"> {{ item.value }} {{ item.physio_param.unit }} </span>
                                                </b>
                                            </el-col>

                                            <el-col :span="12" v-if="itemindex + 1 < operationRoomMonitor.monitor_datas.length">
                                                <b>
                                                    <span :style="{ 'font-size': nameFontSize }">{{
                                                        operationRoomMonitor.monitor_datas[itemindex + 1].physio_param.alias || operationRoomMonitor.monitor_datas[itemindex + 1].physio_param.name
                                                    }}</span>
                                                    <span :class="{ 'fg-danger': operationRoomMonitor.monitor_datas[itemindex + 1].is_warning }" :style="{ 'font-size': dataFontSize }">
                                                        {{ operationRoomMonitor.monitor_datas[itemindex + 1].value }} {{ operationRoomMonitor.monitor_datas[itemindex + 1].physio_param.unit }}
                                                    </span>
                                                </b>
                                            </el-col>
                                        </el-row>
                                    </template>
                                </div>

                                <div class="bottom" style="padding-top: 2px">
                                    <div>
                                        <span
                                            v-for="dv in operationRoomMonitor.surgery_info.use_devices"
                                            :key="dv.id"
                                            class="ellipsis padding5 font-size12"
                                            style="margin-right: 10px; background: #fff; height: 20px; line-height: 20px; display: inline-block; max-width: 100px"
                                            :title="dv.device.name"
                                            >{{ dv.device.name }}</span
                                        >
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>

            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import printJs from 'print-js'
import pdf from '@/common/vue-pdf-4.1.0'
export default {
    name: `SupervisionSurgery`,
    components: { pdf },
    props: {},
    data() {
        return {
            title: `术中监控`,
            monitors: [],
            loadFirst: true,
            c: 1,
            base64: ``,
            pdfvisible: false,
            today: this.$moment().format(`YYYY/MM/DD dddd `),
            checklocationid: ``,
            operationRoomMonitor: null,
            defaultOperatingRoomCount: null,
            dialogVisible: false,
            isShowOperatingDefaultField: 0,
            nameFontSize: `28px`,
            dataFontSize: `38px`,
            rowTototalHeight: 0,
            allMonitorDatas: undefined,
            keepMonitorData: this.$root.KeepMonitorData
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `active_ward`])
    },
    mounted() {
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
        this.c = 1
        this.allMonitorDatas = undefined
        this.loadDefaultOperatingRoomCount()
        this.loadDefaultConfig()
        this.loadSurgeries()
    },
    created() {
        let that = this
        clearInterval(that.interval)
        that.interval = setInterval(() => {
            that.loadSurgeries()
            that.today = this.$moment().format(`YYYY/MM/DD dddd `)
        }, 60000)
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
    methods: {
        autoheight() {
            // 显示默认字段高度 218,当显示默认字段时需在138基础上增加80高度，单行监护数据168,一行监护数据高168-138=30，一行监护数据增加30px
            // 计算公式：不显示默认数据，则高度算法=138+N*30
            // 显示默认字段，高度算法=138+80+N*30;下面通过数据取出最大defaulPhysioparmas数据除以2（除2是因为一行显示两个），若存在余数，则增加一行，整除无需增加
            var contentMinHeight = 168
            var maxCount = 0
            if (this.isShowOperatingDefaultField == `1`) {
                contentMinHeight += 80
            } else if (this.isShowOperatingDefaultField == `2`) {
                contentMinHeight += 27
            }

            if (this.monitors) {
                _.forEach(this.monitors, dts => {
                    if (dts.defaulPhysioparmas) {
                        var defaulCount = dts.defaulPhysioparmas.length
                        if (maxCount < defaulCount) { maxCount = dts.defaulPhysioparmas.length }
                    }
                })
                var rowHeight = 0
                // 整除
                if (maxCount % 2 == 0) {
                    rowHeight = (maxCount / 2) * 30
                } else {
                    // 向下取整
                    var rowCount = maxCount / 2 >> 0
                    // 加一行乘高度30
                    rowHeight = (rowCount + 1) * 30
                }
                contentMinHeight += rowHeight
                this.rowTototalHeight = contentMinHeight
            }
            return contentMinHeight
        },
        loadDefaultConfig() {
            let that = this
            let req = this.myaxios.get(`api/AcisSystem/Config/GetByKey?key=IsShowOperatingDefaultField`) // 获取参数信息
            let req1 = this.myaxios.get(`api/AcisSystem/Config/GetByKey?key=setIntraoperativeMonitorDataFontSize`) // 获取参数信息
            this.myaxios.all(req, req1).then(([data, fontsizes]) => {
                if (data) {
                    that.isShowOperatingDefaultField = data.value
                } else {
                    that.isShowOperatingDefaultField = 0
                }
                if (fontsizes) {
                    let config = JSON.parse(fontsizes.value)
                    if (config.体征名称) {
                        that.nameFontSize = config.体征名称
                    }
                    if (config.数据及单位) {
                        that.dataFontSize = config.数据及单位
                    }
                }
            }).catch(e => {})
        },
        loadDefaultOperatingRoomCount() {
            // TODO:获取参数配置中默认手术间数量
            let that = this
            let req = this.myaxios.get(`api/AcisSystem/Config/GetByKey?key=DefaultOperatingRoomCount`) // 获取参数信息
            req.then(data => {
                if (data) {
                    var count = 0
                    if (data.value > 4) {
                        count = 4
                    } else if (data.value <= 0) {
                        count = 1
                    } else {
                        count = parseInt(data.value)
                    }
                    that.defaultOperatingRoomCount = 24 / count
                } else {
                    that.defaultOperatingRoomCount = 8
                }
            }).catch(e => {})
        },
        IsRescue(p) {
            if (p.surgery_info && p.surgery_info.rescue_segment &&
                p.surgery_info.rescue_segment.begin_time && p.surgery_info.rescue_segment.end_time === null) {
                return true
            }
            return false
        },
        loadSurgeries() {
            let that = this
            if (!that.active_ward || !that.active_ward.operation_room) {
                that.monitors = []
                return
            }
            let req =
                that.c == 1
                    ? that.myaxios.post(
                        `/api/Operation/Monitor/OperatingSurgeryInfos`,
                        _.map(that.active_ward.operation_room, d => d.value)
                    )
                    : []
            let req2 = that.myaxios.post(
                `/api/Operation/Monitor/MonitorDataV2?recordType=1`,
                _.map(that.active_ward.operation_room, d => d.value)
            )
            that.myaxios.all(req, req2).then(([surgeries, datas]) => {
                if (that.keepMonitorData && that.keepMonitorData == `1`) {
                    let oldMonitorDatas = _.cloneDeep(that.allMonitorDatas)
                    if (!that.allMonitorDatas) {
                        console.log(11111)
                        that.allMonitorDatas = datas
                    } else {
                        console.log(22222)
                        console.log(oldMonitorDatas)
                        _.forEach(that.allMonitorDatas, item => {
                            item.monitor_datas = _.filter(item.monitor_datas, d => d.dic_physio_param_id > 0)
                            var newinfo = _.find(datas, d => d.location_id == item.location_id)
                            if (newinfo && newinfo.monitor_datas && newinfo.monitor_datas.length > 0) {
                                // 若无旧数据直接替换
                                if (!item.monitor_datas || item.monitor_datas.length == 0) {
                                    console.log(`Object.assign(item, newinfo)`)
                                    Object.assign(item, newinfo)
                                } else {
                                    let physioparamids = []
                                    // 若有旧数据 循环更新
                                    _.forEach(item.monitor_datas, oldmdata => {
                                        var newval = oldmdata.dic_physio_param_id && _.find(newinfo.monitor_datas, d => d.dic_physio_param_id == oldmdata.dic_physio_param_id)
                                        if (newval && newval.dic_physio_param_id && newval.value != oldmdata.value) {
                                            console.log(`Object.assign(oldmdata, newval)`)
                                            Object.assign(oldmdata, newval)
                                            physioparamids.push(newval.dic_physio_param_id)
                                        }
                                    })
                                    var addlist = _.filter(newinfo.monitor_datas, d => d.dic_physio_param_id && !_.includes(physioparamids, d.dic_physio_param_id) && d.dic_physio_param_id > 0)
                                    addlist && _.forEach(addlist, additem => {
                                        item.monitor_datas.push(additem)
                                    })
                                }
                            }
                        })

                        console.log(33333)
                        console.log(that.allMonitorDatas)
                    }
                } else {
                    that.allMonitorDatas = datas
                }

                if (that.c == 1) {
                    let monitors = _.map(
                        _.filter(that.active_ward.operation_room, d => !d.disabled),
                        d => {
                            return {
                                location_id: d.value,
                                location: d.label,
                                check_result: `未检查`,
                                surgery_info: _.find(surgeries, s => s.dic_operating_room_id == d.value)
                            }
                        }
                    )
                    that.monitors = monitors
                }
                _.forEach(that.allMonitorDatas, dts => {
                    let index = _.findIndex(that.monitors, m => m.location_id == dts.location_id)
                    let r = { ...that.monitors[index] }
                    r.check_result = dts.check_result
                    r.defaulPhysioparmas = dts.defaulPhysioparmas
                    if (dts.defaulPhysioparmas) {
                        let monitordatas = []
                        _.forEach(dts.defaulPhysioparmas, b => {
                            var physioparma = _.find(dts.monitor_datas, c => b.id == c.id || b.id == c.dic_physio_param_id)
                            if (physioparma) {
                                monitordatas.push(physioparma)
                            } else {
                                monitordatas.push({
                                    physio_param: {
                                        id: b.id,
                                        alias: b.alias,
                                        name: b.name,
                                        unit: b.unit
                                    },
                                    is_warning: false,
                                    value: `--`
                                })
                            }
                        })
                        dts.monitor_datas = monitordatas
                        r.monitor_datas = dts.monitor_datas
                        that.$set(that.monitors, index, r)
                    }
                })
                if (that.c < 6) {
                    ++that.c
                } else {
                    that.c = 1
                }
                if (that.checklocationid) {
                    var monitorEntityData = _.find(that.monitors, c => c.location_id == that.checklocationid)
                    if (monitorEntityData) { that.operationRoomMonitor = monitorEntityData }
                }
            })
        },
        findMonitor(monitorDatas, defaultItem) {
            if (!monitorDatas || monitorDatas.length == 0) {
                return undefined
            }
            for (let item of monitorDatas) {
                if (item.physio_param) {
                    let aliasName = (item.physio_param.alias || item.physio_param.name)
                    if (aliasName == defaultItem.alias || aliasName == defaultItem.name) {
                        return item
                    }
                }
            }
            return undefined
        },
        joinWorker(arr) {
            return (arr && _.map(arr, d => d.label).toString()) || `--`
        },
        loadView(p) {
            if (p) {
                var that = this
                that.dialogVisible = true
                that.operationRoomMonitor = p
                that.checklocationid = p.location_id
            }
        },
        loadDocument(p) {
            let req = this.myaxios.post(`/api/Operation/Home/ExportPdf?surgeryInfoId=${p.surgery_info.id}&recordType=1`)
            req.then(data => {
                this.pdfvisible = true
                this.base64 = data
            }).catch(e => console.log(e))
        }
    },
    watch: {
        // operation_ward_auth:function(){
        //   this.loadSurgeries()
        // },
        active_ward: function() {
            this.c = 1
            this.loadSurgeries()
            // this.loadDefaultParams().then(() => {

            // })
        }
    }
}
</script>
<style  lang="less" scoped>
.textoverflow {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.card-header {
    // line-height: 24px;
    text-align: left;
    font-size: 18px;
    font-family: Arial;
    /*background: darkkhaki;*/
}
.card-header-dialog {
    // line-height: 24px;
    text-align: left;
    font-size: 24px;
    font-family: Arial;
    /*background: darkkhaki;*/
}
/deep/ .el-dialog__body {
    padding: 20px 20px 0 20px !important;
    overflow: auto;
    background: #fafafa;
    height: 85vh;
}
/deep/.el-dialog__body .div {
    height: auto;
}
.fontClass {
    font-size: 28px;
}
.fontBClass {
    font-size: 38px;
}
// .tag-border {
//     border: 1px solid rgb(42, 52, 190);
// }
.card-content {
    // padding: 14px;
    height: 100%;
    text-align: left;
    background: #f5f6f7;
    .hand {
        font-size: 14px;
        // color:darkgray;
    }
    .dt {
        color: darkgoldenrod;
    }
    .el-row {
        padding: 2px !important;
    }
    //  .el-col {
    //   padding: 0 !important;
    // }
}
.card-content-dialog {
    // padding: 14px;
    height: 100%;
    text-align: left;
    .hand {
        font-size: 14px;
        // color:darkgray;
    }
    .dt {
        color: darkgoldenrod;
    }
    .el-row {
        padding: 8px !important;
    }
    //  .el-col {
    //   padding: 0 !important;
    // }
}
h1 {
    text-align: left;
    padding: 0;
    font-size: 30px;
    margin: 0;
}
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
.no-bed {
    background: gainsboro;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: lightgrey;
    font-size: 100px;
    background: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/Supervision/Surgery.vue